import React, { FC, memo } from 'react';
import Block from '@views/components/block/Block';
import ReactHtmlParser from 'react-html-parser';
import _decodeHTML from '@helpers/decode-html';

export type DescriptionProp = {
  data: any;
};

const DescriptionComponent: FC<DescriptionProp> = ({ data }) => (
  <Block isSection className="mt-4">
    <Block.Header>
      <Block.Title>CHI TIẾT SẢN PHẨM</Block.Title>
    </Block.Header>
    <Block.Body className="mt-3">
      <Block.Html>
        {/* {ReactHtmlParser(_decodeHTML(data))} */}
        <div dangerouslySetInnerHTML={{ __html: data }} />
      </Block.Html>
    </Block.Body>
  </Block>
);

const Description = memo<DescriptionProp>(DescriptionComponent);
Description.displayName = 'Description';

export default Description;
